import { format } from 'date-fns';

// TODO: find a way to unify the format
export const formatDate = (date: Date | string) =>
  date
    ? format(
        new Date(date.toString().split('/').reverse().join('/')),
        'dd/MM/yyyy'
      )
    : '-';

export const formatDateSubForm = (date: Date | string) =>
  date
    ? format(
        new Date(date.toString().split('/').reverse().join('/')),
        'd MMM, yyyy'
      )
    : '-';

export const transformDate = (date: string | Date) => {
  return format(
    new Date(date.toString().split('/').reverse().join('/')),
    'yyyy-MM-dd'
  );
};

export const formatDateWithTime = (date: Date) =>
  date ? format(new Date(date), 'MM/dd/yyyy - HH:mm') : '-';

export const timeSince = (date: string) => {
  // @ts-ignore
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ' years ago';
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ' months ago';
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ' days ago';
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ' hours ago';
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ' minutes ago';
  }
  return Math.floor(seconds) + ' seconds ago';
};
